<!--
  ~ Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<mat-list>
  <ng-container *ngFor="let item of data.quickFilters">
    <mat-list-item>
      <ng-container *ngTemplateOutlet="item?.template"></ng-container>
    </mat-list-item>
  </ng-container>
  <mat-divider *ngIf="data.inlineFilters"></mat-divider>
  <ng-container *ngFor="let item of data.inlineFilters">
    <mat-list-item>
      <a mat-button (click)="openInlineFilter(item)">{{ item.label }}</a>
    </mat-list-item>
  </ng-container>
  <mat-divider *ngIf="data.filter"></mat-divider>
  <mat-list-item *ngIf="data.filter">
    <ng-container *ngTemplateOutlet="data.filter?.template"></ng-container>
  </mat-list-item>
  <mat-divider *ngIf="data.sort"></mat-divider>
  <mat-list-item *ngIf="data.sort">
    <ng-container *ngTemplateOutlet="data.sort?.template"></ng-container>
  </mat-list-item>
  <mat-divider *ngIf="data.actions"></mat-divider>
  <ng-container *ngFor="let item of data.actions">
    <mat-list-item (click)="actionClicked()">
      <ng-container *ngTemplateOutlet="item?.template"></ng-container>
    </mat-list-item>
  </ng-container>
</mat-list>
